module.exports = __webpack_public_path__ + "8cbf5fdd944f62b5fd60350b739de631.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/saveSuccess.png
// module id = 500
// module chunks = 0